module.exports = __webpack_public_path__ + "img/toilet.0fc7ca57.png";